export interface MangaSeries {
  id: number;
  title: string;
  author: string;
  category: string;
  status: string;
  cover: string;
  intro: string;
  tags: string[];
  lastChapter: string;
  updateDate: string;
  isToday: boolean;
  isNew: boolean;
  isBackfill: boolean;
  isOnHiatus: boolean;
  readers: string;
  rating: number;
  progress: number;
  chapters: { title: string; date: string }[];
}

export const mangaSeries: MangaSeries[] = [
  {
    id: 1,
    title: "星火燎原",
    author: "墨羽工作室",
    category: "热血",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20manga%20cover%20art%20of%20a%20young%20boy%20wielding%20a%20blazing%20fire%20sword%20standing%20boldly%2C%20flame%20wings%20behind%20him%2C%20vibrant%20orange%20and%20red%20energy%20with%20sparks%2C%20dynamic%20heroic%20pose%2C%20clean%20warm%20cream%20background%2C%20high%20detail%20illustration%2C%20editorial%20comic%20cover%20composition&width=600&height=800&seq=manga-cover-01&orientation=portrait",
    intro: "平凡少年林烬在一次山火中觉醒了沉寂千年的星火之力，从此踏上守护故土、对抗天灾的征途。燃烧的星火既是他力量的源泉，也是他必须背负的宿命。",
    tags: ["少年热血", "战斗", "成长"],
    lastChapter: "第286话 燎原之势",
    updateDate: "2026-08-18",
    isToday: true,
    isNew: false,
    isBackfill: false,
    isOnHiatus: false,
    readers: "128.4万",
    rating: 9.4,
    progress: 72,
    chapters: [
      { title: "第286话 燎原之势", date: "2026-08-18" },
      { title: "第285话 薪火相传", date: "2026-08-11" },
      { title: "第284话 灰烬之心", date: "2026-08-04" },
      { title: "第283话 逆风点火", date: "2026-07-28" },
      { title: "第282话 星火初燃", date: "2026-07-21" },
    ],
  },
  {
    id: 2,
    title: "剑冢传人",
    author: "孤山铸剑",
    category: "玄幻",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20manga%20cover%20art%20of%20a%20calm%20swordsman%20holding%20a%20long%20ancient%20sword%20on%20a%20misty%20mountain%20ridge%2C%20gently%20glowing%20blade%20edge%2C%20golden%20and%20jade%20green%20tone%2C%20quiet%20heroic%20atmosphere%2C%20clean%20warm%20cream%20background%2C%20high%20detail%20anime%20illustration%2C%20comic%20cover%20composition&width=600&height=800&seq=manga-cover-02&orientation=portrait",
    intro: "少年顾清寒背着一柄从古剑冢里捡到的锈剑下山，却不知这把剑里封印着上古剑灵。剑冢里的秘密，将随着他一步步揭开这个世界的真相。",
    tags: ["修真", "剑道", "古风"],
    lastChapter: "第174话 剑心通明",
    updateDate: "2026-08-17",
    isToday: false,
    isNew: false,
    isBackfill: false,
    isOnHiatus: false,
    readers: "96.8万",
    rating: 9.1,
    progress: 44,
    chapters: [
      { title: "第174话 剑心通明", date: "2026-08-17" },
      { title: "第173话 万剑归宗", date: "2026-08-10" },
      { title: "第172话 藏锋", date: "2026-08-03" },
    ],
  },
  {
    id: 3,
    title: "深夜食堂侦探",
    author: "一碗夜宵",
    category: "悬疑",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20manga%20cover%20art%20of%20a%20mysterious%20night%20diner%20with%20warm%20lamp%20light%2C%20a%20detective%20figure%20silhouette%20holding%20a%20bowl%20of%20noodles%2C%20cozy%20noir%20mood%2C%20soft%20orange%20and%20amber%20tone%2C%20clean%20warm%20cream%20background%2C%20high%20detail%20anime%20illustration%2C%20comic%20cover%20composition&width=600&height=800&seq=manga-cover-03&orientation=portrait",
    intro: "深夜十一点，街角的食堂准时亮起灯。每个客人带着一桩悬案而来，而老板只用一碗热汤，就能揭开他们心底的秘密。",
    tags: ["推理", "治愈", "美食"],
    lastChapter: "第98话 深夜来信",
    updateDate: "2026-08-15",
    isToday: false,
    isNew: false,
    isBackfill: false,
    isOnHiatus: false,
    readers: "62.1万",
    rating: 8.8,
    progress: 50,
    chapters: [
      { title: "第98话 深夜来信", date: "2026-08-15" },
      { title: "第97话 一碗冷面", date: "2026-08-08" },
      { title: "第96话 雨夜来客", date: "2026-08-01" },
    ],
  },
  {
    id: 4,
    title: "恋恋手账",
    author: "糖分补给站",
    category: "恋爱",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20manga%20cover%20art%20of%20a%20blushing%20girl%20holding%20a%20handmade%20journal%20with%20sticker%20decorations%2C%20cherry%20blossom%20petals%20floating%2C%20sweet%20soft%20pink%20and%20warm%20peach%20tone%2C%20clean%20warm%20cream%20background%2C%20high%20detail%20anime%20illustration%2C%20romance%20comic%20cover%20composition&width=600&height=800&seq=manga-cover-04&orientation=portrait",
    intro: "高三少女白桃用一本手账记录下与同桌之间每一个心动瞬间。当手账被意外翻开，那些偷偷藏起来的心意，再也藏不住了。",
    tags: ["校园", "纯爱", "日常"],
    lastChapter: "第132话 心意交换",
    updateDate: "2026-08-18",
    isToday: true,
    isNew: false,
    isBackfill: false,
    isOnHiatus: false,
    readers: "54.7万",
    rating: 8.7,
    progress: 66,
    chapters: [
      { title: "第132话 心意交换", date: "2026-08-18" },
      { title: "第131话 手账的秘密", date: "2026-08-11" },
      { title: "第130话 操场边的风", date: "2026-08-04" },
    ],
  },
  {
    id: 5,
    title: "钢铁堡垒",
    author: "齿轮与蒸汽",
    category: "科幻",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20manga%20cover%20art%20of%20a%20young%20pilot%20inside%20a%20giant%20mech%20suit%20in%20a%20high%20tech%20steel%20city%2C%20glowing%20teal%20circuit%20lights%20and%20orange%20warnings%2C%20clean%20warm%20cream%20background%2C%20high%20detail%20anime%20illustration%2C%20sci%20fi%20comic%20cover%20composition&width=600&height=800&seq=manga-cover-05&orientation=portrait",
    intro: "末日之后，人类躲进了钢铁堡垒。少年机甲驾驶员陈望，在一次次出击中逐渐揭开堡垒建立的真相——而真相，远比战争更残酷。",
    tags: ["机甲", "末世", "战争"],
    lastChapter: "第211话 破晓之墙",
    updateDate: "2026-08-16",
    isToday: false,
    isNew: false,
    isBackfill: false,
    isOnHiatus: false,
    readers: "83.5万",
    rating: 9.0,
    progress: 78,
    chapters: [
      { title: "第211话 破晓之墙", date: "2026-08-16" },
      { title: "第210话 最后防线", date: "2026-08-09" },
      { title: "第209话 钢铁意志", date: "2026-08-02" },
    ],
  },
  {
    id: 6,
    title: "都市捉妖人",
    author: "雨夜老巷",
    category: "都市",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20manga%20cover%20art%20of%20a%20young%20exorcist%20with%20a%20talisman%20scroll%20standing%20on%20a%20rainy%20modern%20city%20street%20at%20night%2C%20mystical%20blue%20and%20teal%20glow%2C%20clean%20warm%20cream%20background%2C%20high%20detail%20anime%20illustration%2C%20urban%20fantasy%20comic%20cover%20composition&width=600&height=800&seq=manga-cover-06&orientation=portrait",
    intro: "白天他是朝九晚五的普通职员，夜里他是穿梭都市的捉妖人。这座城市光鲜的外表下，藏着多少不为人知的妖怪与恩怨。",
    tags: ["都市奇幻", "妖怪", "热血"],
    lastChapter: "第156话 灯下影",
    updateDate: "2026-08-14",
    isToday: false,
    isNew: false,
    isBackfill: false,
    isOnHiatus: false,
    readers: "71.3万",
    rating: 8.9,
    progress: 60,
    chapters: [
      { title: "第156话 灯下影", date: "2026-08-14" },
      { title: "第155话 夜班车", date: "2026-08-07" },
      { title: "第154话 巷口灯火", date: "2026-07-31" },
    ],
  },
  {
    id: 7,
    title: "萌宠大冒险",
    author: "爪子出版社",
    category: "搞笑",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20manga%20cover%20art%20of%20a%20group%20of%20cute%20animals%20including%20a%20cat%20dog%20and%20rabbit%20on%20an%20adventure%20with%20a%20little%20treasure%20map%2C%20bright%20warm%20yellow%20and%20orange%20tone%2C%20playful%20fun%20atmosphere%2C%20clean%20warm%20cream%20background%2C%20high%20detail%20anime%20illustration%2C%20comedy%20comic%20cover%20composition&width=600&height=800&seq=manga-cover-07&orientation=portrait",
    intro: "小柴犬阿黄捡到一张藏宝图，带着猫、兔子和小仓鼠踏上寻宝之旅。一路上笑料百出，原来宝藏就在朋友之间。",
    tags: ["动物", "搞笑", "治愈"],
    lastChapter: "第78话 藏宝图",
    updateDate: "2026-08-13",
    isToday: false,
    isNew: false,
    isBackfill: false,
    isOnHiatus: false,
    readers: "43.9万",
    rating: 8.6,
    progress: 35,
    chapters: [
      { title: "第78话 藏宝图", date: "2026-08-13" },
      { title: "第77话 神秘的洞", date: "2026-08-06" },
      { title: "第76话 森林野餐", date: "2026-07-30" },
    ],
  },
  {
    id: 8,
    title: "苍岚学院",
    author: "白鹭绘卷",
    category: "冒险",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20manga%20cover%20art%20of%20teenage%20students%20in%20uniform%20facing%20a%20huge%20floating%20sky%20academy%20with%20airships%2C%20adventurous%20spirit%2C%20teal%20and%20warm%20amber%20tone%2C%20clean%20warm%20cream%20background%2C%20high%20detail%20anime%20illustration%2C%20adventure%20comic%20cover%20composition&width=600&height=800&seq=manga-cover-08&orientation=portrait",
    intro: "传说只有被风选中的人才能进入漂浮在云端的苍岚学院。少年叶辰带着一张入学邀请函，踏上了属于他的冒险之旅。",
    tags: ["学院", "冒险", "魔法"],
    lastChapter: "第89话 云端试炼",
    updateDate: "2026-08-12",
    isToday: false,
    isNew: false,
    isBackfill: false,
    isOnHiatus: false,
    readers: "58.2万",
    rating: 8.8,
    progress: 40,
    chapters: [
      { title: "第89话 云端试炼", date: "2026-08-12" },
      { title: "第88话 风之试炼", date: "2026-08-05" },
      { title: "第87话 新生报到", date: "2026-07-29" },
    ],
  },
  {
    id: 9,
    title: "逆流武者",
    author: "石中之火",
    category: "热血",
    status: "暂停更新",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20manga%20cover%20art%20of%20a%20brooding%20martial%20artist%20meditating%20beside%20a%20waterfall%20with%20falling%20leaves%2C%20subdued%20warm%20grey%20and%20amber%20tone%2C%20calm%20yet%20intense%20mood%2C%20clean%20warm%20cream%20background%2C%20high%20detail%20anime%20illustration%2C%20comic%20cover%20composition&width=600&height=800&seq=manga-cover-09&orientation=portrait",
    intro: "一个被逐出师门的武者，顺着逆流的河水一路向前。他要在所有人都说他不行的地方，走出自己的路。",
    tags: ["武侠", "励志", "热血"],
    lastChapter: "第167话 逆流而上",
    updateDate: "2026-08-02",
    isToday: false,
    isNew: false,
    isBackfill: false,
    isOnHiatus: true,
    readers: "88.6万",
    rating: 9.2,
    progress: 55,
    chapters: [
      { title: "第167话 逆流而上", date: "2026-08-02" },
      { title: "第166话 静水流深", date: "2026-07-26" },
      { title: "第165话 逆水行舟", date: "2026-07-19" },
    ],
  },
  {
    id: 10,
    title: "春日信号",
    author: "南风绘",
    category: "恋爱",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20manga%20cover%20art%20of%20two%20high%20school%20students%20on%20a%20spring%20field%20with%20green%20grass%20and%20soft%20sunlight%2C%20sweet%20gentle%20mood%2C%20warm%20green%20and%20peach%20tone%2C%20clean%20warm%20cream%20background%2C%20high%20detail%20anime%20illustration%2C%20romance%20comic%20cover%20composition&width=600&height=800&seq=manga-cover-10&orientation=portrait",
    intro: "每到春天，广播里就会响起信号声。内向的少年鼓起勇气，把藏在练习本里的情书，交到了那个女孩手里。",
    tags: ["青春", "纯爱", "治愈"],
    lastChapter: "第105话 春天的答案",
    updateDate: "2026-08-18",
    isToday: true,
    isNew: false,
    isBackfill: false,
    isOnHiatus: false,
    readers: "47.5万",
    rating: 8.7,
    progress: 53,
    chapters: [
      { title: "第105话 春天的答案", date: "2026-08-18" },
      { title: "第104话 广播时间", date: "2026-08-11" },
      { title: "第103话 练习本", date: "2026-08-04" },
    ],
  },
  {
    id: 11,
    title: "量子边界",
    author: "星环实验室",
    category: "科幻",
    status: "补更",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20manga%20cover%20art%20of%20a%20young%20scientist%20standing%20between%20parallel%20glowing%20dimensions%20with%20light%20particles%2C%20mysterious%20deep%20teal%20and%20violet%20energy%2C%20clean%20warm%20cream%20background%2C%20high%20detail%20anime%20illustration%2C%20sci%20fi%20comic%20cover%20composition&width=600&height=800&seq=manga-cover-11&orientation=portrait",
    intro: "物理系研究生苏晚，在一次实验中意外打开量子边界，看见了平行世界里另一个自己。两个世界之间，只能留下一个。",
    tags: ["量子", "平行世界", "悬疑"],
    lastChapter: "第143话 重叠时空",
    updateDate: "2026-08-18",
    isToday: false,
    isNew: false,
    isBackfill: true,
    isOnHiatus: false,
    readers: "66.9万",
    rating: 8.9,
    progress: 68,
    chapters: [
      { title: "第143话 重叠时空", date: "2026-08-18" },
      { title: "第142话 另一条线", date: "2026-07-25" },
      { title: "第141话 边界之外", date: "2026-07-18" },
    ],
  },
  {
    id: 12,
    title: "山海少年志",
    author: "青丘工作室",
    category: "冒险",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20manga%20cover%20art%20of%20a%20young%20boy%20riding%20a%20giant%20mythical%20bird%20over%20mountains%20and%20clouds%2C%20ancient%20chinese%20mythology%20flavor%2C%20warm%20teal%20and%20gold%20tone%2C%20clean%20warm%20cream%20background%2C%20high%20detail%20anime%20illustration%2C%20adventure%20comic%20cover%20composition&width=600&height=800&seq=manga-cover-12&orientation=portrait",
    intro: "少年阿满误入山海之间，结识了会说话的神鸟，踏上了寻找失落的九条尾巴的旅程。山海之间，藏着中华神话的古老秘密。",
    tags: ["神话", "冒险", "中国风"],
    lastChapter: "第66话 九尾传说",
    updateDate: "2026-08-18",
    isToday: true,
    isNew: true,
    isBackfill: false,
    isOnHiatus: false,
    readers: "39.3万",
    rating: 8.5,
    progress: 30,
    chapters: [
      { title: "第66话 九尾传说", date: "2026-08-18" },
      { title: "第65话 神鸟之约", date: "2026-08-11" },
      { title: "第64话 山门之外", date: "2026-08-04" },
    ],
  },
];

export const categories = [
  { name: "热血", icon: "ri-fire-line", count: 6 },
  { name: "冒险", icon: "ri-compass-line", count: 5 },
  { name: "恋爱", icon: "ri-heart-line", count: 4 },
  { name: "悬疑", icon: "ri-search-eye-line", count: 3 },
  { name: "玄幻", icon: "ri-sword-line", count: 4 },
  { name: "都市", icon: "ri-building-line", count: 3 },
  { name: "搞笑", icon: "ri-emotion-happy-line", count: 3 },
  { name: "科幻", icon: "ri-rocket-line", count: 3 },
];

export const faqList = [
  {
    q: "66漫画网的更新动态多久刷新一次？",
    a: "66漫画网会实时同步各连载漫画的最新更新情况，本站的「更新动态」板块会持续刷新，确保你能第一时间看到最新话、今天更新、补更与断更等状态变化。",
  },
  {
    q: "「最新话抢先看」是什么意思？",
    a: "「最新话抢先看」是指漫画单行本或网络连载发布最新章节后，66漫画网会第一时间整理更新动态并标记出来，方便追更的读者第一时间掌握进度、抢先查看最新话内容。",
  },
  {
    q: "「补更」和「断更」有什么区别？",
    a: "「补更」指因故暂停后恢复更新、一次性补充多话的情况；「断更」则指某部漫画因作者或平台原因暂停更新。66漫画网会用不同标记清晰区分这两类动态。",
  },
  {
    q: "如何一键查看自己的追更进度？",
    a: "在漫画详情页可以查看该漫画已更新的全部章节与当前进度。你可以把常看的漫画加入追更书架，之后在「追更书架」中一键查看每部漫画的最新进度。",
  },
  {
    q: "追更动态会推送提醒吗？",
    a: "当前版本会在「更新动态」板块集中展示所有更新情况。若你希望第一时间收到提醒，可以多留意最新话与今天更新的高亮标记。",
  },
  {
    q: "66漫画网的内容来源正规吗？",
    a: "66漫画网专注整理与呈现漫画更新动态信息，所有动态均以官方或授权渠道发布为准，本站只做信息的汇总与进度追踪，不提供未经授权的转载内容。",
  },
];